// @flow

import * as React from "react"
import { connect, type Connector } from "react-redux"
import Value from "@kiwicom/nitro/lib/components/Value"
import ModalsAuth from "@kiwicom/nitro/lib/components/ModalsAuth"
import { Provider as ModalProvider } from "@kiwicom/nitro/lib/services/modal/context"
import { SIGN_IN, REGISTER, MY_BOOKING, FORGOT_PASSWORD } from "@kiwicom/nitro/lib/consts/modals"

import NitroProvider from "../NitroProvider"
import MagicLogin from "../../modules/MagicLogin"
import { TAB_TYPES as LoginModalTypes } from "../../consts/account"
import { hideBelowModals } from "../../modules/SmartFAQ/services/SmartFAQDuck"

type OwnProps = {|
  type: "mmb" | "help" | "refer",
  initialScreen: $Values<typeof LoginModalTypes>,
  disableSocialLogin: boolean,
  onClose: () => void,
|}

type Props = {|
  ...OwnProps,
  useMagicLogin: boolean,
  hideSmartFAQ: (hideSmartFAQ: boolean) => void,
|}

const LoginModal = ({
  type,
  initialScreen,
  disableSocialLogin,
  useMagicLogin,
  onClose,
  hideSmartFAQ,
}: Props) => {
  React.useEffect(() => {
    hideSmartFAQ(true)

    return () => hideSmartFAQ(false)
  })
  if (useMagicLogin) {
    const initialMagicScreen = initialScreen === "register" ? "signUp" : "intro"

    return (
      <NitroProvider
        intl={window.__INTL__}
        brand={window.__BRAND__}
        fetched={window.__FETCHED__}
        session={window.__SESSION__}
        orbit={window.__ORBIT__}
      >
        <MagicLogin
          onClose={onClose}
          type={type}
          initialScreen={initialMagicScreen}
          disableSocialLogin={disableSocialLogin}
        />
      </NitroProvider>
    )
  }

  return (
    <NitroProvider
      intl={window.__INTL__}
      brand={window.__BRAND__}
      fetched={window.__FETCHED__}
      session={window.__SESSION__}
      orbit={window.__ORBIT__}
    >
      <Value initial={initialScreen}>
        {({ value, onChange }) => {
          const onChangeModal = modalType => {
            if (![SIGN_IN, REGISTER, MY_BOOKING, FORGOT_PASSWORD].includes(modalType)) {
              onClose()
              return
            }

            onChange(modalType)
          }

          return (
            <ModalProvider value={{ onChange: onChangeModal, value }}>
              <ModalsAuth portal="modals" />
            </ModalProvider>
          )
        }}
      </Value>
    </NitroProvider>
  )
}

const connector: Connector<OwnProps, Props> = connect(
  state => ({
    useMagicLogin: state.splitster.get("MAGIC_LOGIN").value === "on",
  }),
  {
    hideSmartFAQ: hideBelowModals,
  },
)

export default connector(LoginModal)
